import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import getDeliveryDocuments from '../../repository/delivery-documents/raw-milk/getDeliveryDocuments';
import getDeliveryDocumentVersions from '../../repository/delivery-documents/raw-milk/getDeliveryDocumentVersions';
import generateReport from '../../repository/route-sessions/delivery-reports/generateDeliveryReport';

export const DELIVERY_DOCUMENTS_KEY = 'delivery-documents';

export const useGetDeliveryDocuments = (params, { enabled = true } = {}) =>
    useQuery({
        queryKey: [DELIVERY_DOCUMENTS_KEY, params],
        queryFn: () => getDeliveryDocuments(params),
        enabled,
        keepPreviousData: true,
    });

export const useGetDeliveryDocumentVersions = (id) =>
    useQuery({
        queryKey: [DELIVERY_DOCUMENTS_KEY, 'versions', id],
        queryFn: () => getDeliveryDocumentVersions(id),
        enabled: !!id,
    });

export const useGenerateDeliveryDocument = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id }) => generateReport({ resourceId: id }),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: [DELIVERY_DOCUMENTS_KEY] }),
    });
};
